export default "__VITE_ASSET__DVQI64FA__"